// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/datagateway/v1/capture_outputs.proto (package mono.datagateway.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3 } from "@bufbuild/protobuf";
/**
 * SAD-505: internal capture-review source projection, never external-release authority.
 *
 * @generated from message mono.datagateway.v1.CaptureOutputSource
 */ export class CaptureOutputSource extends Message {
    static fromBinary(bytes, options) {
        return new CaptureOutputSource().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureOutputSource().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureOutputSource().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureOutputSource, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", ""), /**
   * Immutable revision ID, or sha256 of the exact projected row for mutable sources.
   *
   * @generated from field: string version = 3;
   */ _define_property(this, "version", ""), /**
   * @generated from field: string as_of = 4;
   */ _define_property(this, "asOf", ""), /**
   * JSON of permitted owning content; no generated filler or raw Delivery traversal.
   *
   * @generated from field: string content_json = 5;
   */ _define_property(this, "contentJson", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureOutputSource, "runtime", proto3);
_define_property(CaptureOutputSource, "typeName", "mono.datagateway.v1.CaptureOutputSource");
_define_property(CaptureOutputSource, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "version",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "as_of",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "content_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CaptureOutputSection
 */ export class CaptureOutputSection extends Message {
    static fromBinary(bytes, options) {
        return new CaptureOutputSection().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureOutputSection().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureOutputSection().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureOutputSection, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string key = 1;
   */ _define_property(this, "key", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string owner = 3;
   */ _define_property(this, "owner", ""), /**
   * ready | partial | missing; internal content coverage only.
   *
   * @generated from field: string readiness = 4;
   */ _define_property(this, "readiness", ""), /**
   * @generated from field: string reason = 5;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: int32 satisfied = 6;
   */ _define_property(this, "satisfied", 0), /**
   * @generated from field: int32 required = 7;
   */ _define_property(this, "required", 0), /**
   * @generated from field: repeated string missing_criteria = 8;
   */ _define_property(this, "missingCriteria", []), /**
   * @generated from field: repeated mono.datagateway.v1.CaptureOutputSource sources = 9;
   */ _define_property(this, "sources", []), /**
   * @generated from field: mono.datagateway.v1.CaptureOutputMaterial manual_material = 10;
   */ _define_property(this, "manualMaterial", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureOutputSection, "runtime", proto3);
_define_property(CaptureOutputSection, "typeName", "mono.datagateway.v1.CaptureOutputSection");
_define_property(CaptureOutputSection, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "owner",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "readiness",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "satisfied",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "required",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "missing_criteria",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 9,
            name: "sources",
            kind: "message",
            T: CaptureOutputSource,
            repeated: true
        },
        {
            no: 10,
            name: "manual_material",
            kind: "message",
            T: CaptureOutputMaterial
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CaptureOutputMaterial
 */ export class CaptureOutputMaterial extends Message {
    static fromBinary(bytes, options) {
        return new CaptureOutputMaterial().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureOutputMaterial().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureOutputMaterial().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureOutputMaterial, a, b);
    }
    constructor(data){
        super(), /**
   * Immutable version row ID.
   *
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * Stable canonical material identity for this Pursuit/section.
   *
   * @generated from field: string material_id = 2;
   */ _define_property(this, "materialId", ""), /**
   * @generated from field: string section_key = 3;
   */ _define_property(this, "sectionKey", ""), /**
   * @generated from field: int32 version = 4;
   */ _define_property(this, "version", 0), /**
   * @generated from field: string narrative = 5;
   */ _define_property(this, "narrative", ""), /**
   * @generated from field: string evidence = 6;
   */ _define_property(this, "evidence", ""), /**
   * @generated from field: string limitations = 7;
   */ _define_property(this, "limitations", ""), /**
   * Internal capture review only, never external approval.
   *
   * @generated from field: bool reviewed = 8;
   */ _define_property(this, "reviewed", false), /**
   * @generated from field: string created_at = 9;
   */ _define_property(this, "createdAt", ""), /**
   * @generated from field: string created_by = 10;
   */ _define_property(this, "createdBy", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureOutputMaterial, "runtime", proto3);
_define_property(CaptureOutputMaterial, "typeName", "mono.datagateway.v1.CaptureOutputMaterial");
_define_property(CaptureOutputMaterial, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "material_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "section_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "narrative",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "evidence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "limitations",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "reviewed",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 9,
            name: "created_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * Canonical competitor participant IDs identify assessment chains; sources freeze row IDs.
 *
 * @generated from message mono.datagateway.v1.CaptureOutputContext
 */ export class CaptureOutputContext extends Message {
    static fromBinary(bytes, options) {
        return new CaptureOutputContext().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureOutputContext().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureOutputContext().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureOutputContext, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string purpose = 1;
   */ _define_property(this, "purpose", ""), /**
   * @generated from field: string audience = 2;
   */ _define_property(this, "audience", ""), /**
   * @generated from field: repeated string participant_ids = 3;
   */ _define_property(this, "participantIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureOutputContext, "runtime", proto3);
_define_property(CaptureOutputContext, "typeName", "mono.datagateway.v1.CaptureOutputContext");
_define_property(CaptureOutputContext, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "purpose",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "audience",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "participant_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CaptureOutputProjection
 */ export class CaptureOutputProjection extends Message {
    static fromBinary(bytes, options) {
        return new CaptureOutputProjection().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureOutputProjection().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureOutputProjection().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureOutputProjection, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string template_id = 2;
   */ _define_property(this, "templateId", ""), /**
   * @generated from field: string as_of = 3;
   */ _define_property(this, "asOf", ""), /**
   * @generated from field: repeated mono.datagateway.v1.CaptureOutputSection sections = 4;
   */ _define_property(this, "sections", []), /**
   * @generated from field: int32 ready_sections = 5;
   */ _define_property(this, "readySections", 0), /**
   * @generated from field: int32 total_sections = 6;
   */ _define_property(this, "totalSections", 0), /**
   * @generated from field: string readiness_basis = 7;
   */ _define_property(this, "readinessBasis", ""), /**
   * @generated from field: mono.datagateway.v1.CaptureOutputContext context = 8;
   */ _define_property(this, "context", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureOutputProjection, "runtime", proto3);
_define_property(CaptureOutputProjection, "typeName", "mono.datagateway.v1.CaptureOutputProjection");
_define_property(CaptureOutputProjection, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "template_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "as_of",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "sections",
            kind: "message",
            T: CaptureOutputSection,
            repeated: true
        },
        {
            no: 5,
            name: "ready_sections",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "total_sections",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "readiness_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "context",
            kind: "message",
            T: CaptureOutputContext
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CaptureOutputSnapshot
 */ export class CaptureOutputSnapshot extends Message {
    static fromBinary(bytes, options) {
        return new CaptureOutputSnapshot().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureOutputSnapshot().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureOutputSnapshot().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureOutputSnapshot, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: int32 version = 2;
   */ _define_property(this, "version", 0), /**
   * @generated from field: string purpose = 3;
   */ _define_property(this, "purpose", ""), /**
   * @generated from field: string created_at = 4;
   */ _define_property(this, "createdAt", ""), /**
   * @generated from field: string created_by = 5;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: mono.datagateway.v1.CaptureOutputProjection projection = 6;
   */ _define_property(this, "projection", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureOutputSnapshot, "runtime", proto3);
_define_property(CaptureOutputSnapshot, "typeName", "mono.datagateway.v1.CaptureOutputSnapshot");
_define_property(CaptureOutputSnapshot, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "purpose",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "created_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "projection",
            kind: "message",
            T: CaptureOutputProjection
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetCaptureOutputsRequest
 */ export class GetCaptureOutputsRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetCaptureOutputsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCaptureOutputsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCaptureOutputsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCaptureOutputsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string capture_project_id = 3;
   */ _define_property(this, "captureProjectId", ""), /**
   * Empty defaults to capture-review-v1; also leadership-review-v1.
   *
   * @generated from field: string template_id = 4;
   */ _define_property(this, "templateId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCaptureOutputsRequest, "runtime", proto3);
_define_property(GetCaptureOutputsRequest, "typeName", "mono.datagateway.v1.GetCaptureOutputsRequest");
_define_property(GetCaptureOutputsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "template_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetCaptureOutputsResponse
 */ export class GetCaptureOutputsResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetCaptureOutputsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCaptureOutputsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCaptureOutputsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCaptureOutputsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CaptureOutputProjection projection = 1;
   */ _define_property(this, "projection", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.CaptureOutputMaterial material_history = 2;
   */ _define_property(this, "materialHistory", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCaptureOutputsResponse, "runtime", proto3);
_define_property(GetCaptureOutputsResponse, "typeName", "mono.datagateway.v1.GetCaptureOutputsResponse");
_define_property(GetCaptureOutputsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "projection",
            kind: "message",
            T: CaptureOutputProjection
        },
        {
            no: 2,
            name: "material_history",
            kind: "message",
            T: CaptureOutputMaterial,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SaveCaptureOutputMaterialRequest
 */ export class SaveCaptureOutputMaterialRequest extends Message {
    static fromBinary(bytes, options) {
        return new SaveCaptureOutputMaterialRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveCaptureOutputMaterialRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveCaptureOutputMaterialRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveCaptureOutputMaterialRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string capture_project_id = 3;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string section_key = 4;
   */ _define_property(this, "sectionKey", ""), /**
   * @generated from field: int32 expected_version = 5;
   */ _define_property(this, "expectedVersion", 0), /**
   * @generated from field: string narrative = 6;
   */ _define_property(this, "narrative", ""), /**
   * @generated from field: string evidence = 7;
   */ _define_property(this, "evidence", ""), /**
   * @generated from field: string limitations = 8;
   */ _define_property(this, "limitations", ""), /**
   * @generated from field: bool reviewed = 9;
   */ _define_property(this, "reviewed", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveCaptureOutputMaterialRequest, "runtime", proto3);
_define_property(SaveCaptureOutputMaterialRequest, "typeName", "mono.datagateway.v1.SaveCaptureOutputMaterialRequest");
_define_property(SaveCaptureOutputMaterialRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "section_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "expected_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "narrative",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "evidence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "limitations",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "reviewed",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SaveCaptureOutputMaterialResponse
 */ export class SaveCaptureOutputMaterialResponse extends Message {
    static fromBinary(bytes, options) {
        return new SaveCaptureOutputMaterialResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveCaptureOutputMaterialResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveCaptureOutputMaterialResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveCaptureOutputMaterialResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CaptureOutputMaterial material = 1;
   */ _define_property(this, "material", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveCaptureOutputMaterialResponse, "runtime", proto3);
_define_property(SaveCaptureOutputMaterialResponse, "typeName", "mono.datagateway.v1.SaveCaptureOutputMaterialResponse");
_define_property(SaveCaptureOutputMaterialResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "material",
            kind: "message",
            T: CaptureOutputMaterial
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SaveCaptureOutputSnapshotRequest
 */ export class SaveCaptureOutputSnapshotRequest extends Message {
    static fromBinary(bytes, options) {
        return new SaveCaptureOutputSnapshotRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveCaptureOutputSnapshotRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveCaptureOutputSnapshotRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveCaptureOutputSnapshotRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string capture_project_id = 3;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string template_id = 4;
   */ _define_property(this, "templateId", ""), /**
   * @generated from field: string purpose = 5;
   */ _define_property(this, "purpose", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveCaptureOutputSnapshotRequest, "runtime", proto3);
_define_property(SaveCaptureOutputSnapshotRequest, "typeName", "mono.datagateway.v1.SaveCaptureOutputSnapshotRequest");
_define_property(SaveCaptureOutputSnapshotRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "template_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "purpose",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SaveCaptureOutputSnapshotResponse
 */ export class SaveCaptureOutputSnapshotResponse extends Message {
    static fromBinary(bytes, options) {
        return new SaveCaptureOutputSnapshotResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveCaptureOutputSnapshotResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveCaptureOutputSnapshotResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveCaptureOutputSnapshotResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CaptureOutputSnapshot snapshot = 1;
   */ _define_property(this, "snapshot", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveCaptureOutputSnapshotResponse, "runtime", proto3);
_define_property(SaveCaptureOutputSnapshotResponse, "typeName", "mono.datagateway.v1.SaveCaptureOutputSnapshotResponse");
_define_property(SaveCaptureOutputSnapshotResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "snapshot",
            kind: "message",
            T: CaptureOutputSnapshot
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCaptureOutputSnapshotsRequest
 */ export class ListCaptureOutputSnapshotsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureOutputSnapshotsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureOutputSnapshotsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureOutputSnapshotsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureOutputSnapshotsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string capture_project_id = 3;
   */ _define_property(this, "captureProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureOutputSnapshotsRequest, "runtime", proto3);
_define_property(ListCaptureOutputSnapshotsRequest, "typeName", "mono.datagateway.v1.ListCaptureOutputSnapshotsRequest");
_define_property(ListCaptureOutputSnapshotsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCaptureOutputSnapshotsResponse
 */ export class ListCaptureOutputSnapshotsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureOutputSnapshotsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureOutputSnapshotsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureOutputSnapshotsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureOutputSnapshotsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.CaptureOutputSnapshot snapshots = 1;
   */ _define_property(this, "snapshots", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureOutputSnapshotsResponse, "runtime", proto3);
_define_property(ListCaptureOutputSnapshotsResponse, "typeName", "mono.datagateway.v1.ListCaptureOutputSnapshotsResponse");
_define_property(ListCaptureOutputSnapshotsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "snapshots",
            kind: "message",
            T: CaptureOutputSnapshot,
            repeated: true
        }
    ]));
/**
 * SAD-509: presentation edits never write into the owning source records.
 *
 * @generated from message mono.datagateway.v1.CaptureOutputOverride
 */ export class CaptureOutputOverride extends Message {
    static fromBinary(bytes, options) {
        return new CaptureOutputOverride().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureOutputOverride().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureOutputOverride().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureOutputOverride, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string section_key = 1;
   */ _define_property(this, "sectionKey", ""), /**
   * @generated from field: string wording = 2;
   */ _define_property(this, "wording", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureOutputOverride, "runtime", proto3);
_define_property(CaptureOutputOverride, "typeName", "mono.datagateway.v1.CaptureOutputOverride");
_define_property(CaptureOutputOverride, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "section_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "wording",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CaptureOutputOverrideDecision
 */ export class CaptureOutputOverrideDecision extends Message {
    static fromBinary(bytes, options) {
        return new CaptureOutputOverrideDecision().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureOutputOverrideDecision().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureOutputOverrideDecision().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureOutputOverrideDecision, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string section_key = 1;
   */ _define_property(this, "sectionKey", ""), /**
   * preserve | replace
   *
   * @generated from field: string action = 2;
   */ _define_property(this, "action", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureOutputOverrideDecision, "runtime", proto3);
_define_property(CaptureOutputOverrideDecision, "typeName", "mono.datagateway.v1.CaptureOutputOverrideDecision");
_define_property(CaptureOutputOverrideDecision, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "section_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "action",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CaptureOutputVersion
 */ export class CaptureOutputVersion extends Message {
    static fromBinary(bytes, options) {
        return new CaptureOutputVersion().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureOutputVersion().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureOutputVersion().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureOutputVersion, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string output_id = 2;
   */ _define_property(this, "outputId", ""), /**
   * @generated from field: string parent_id = 3;
   */ _define_property(this, "parentId", ""), /**
   * @generated from field: int32 version = 4;
   */ _define_property(this, "version", 0), /**
   * generate | edit | regenerate | external
   *
   * @generated from field: string operation = 5;
   */ _define_property(this, "operation", ""), /**
   * @generated from field: string created_at = 6;
   */ _define_property(this, "createdAt", ""), /**
   * @generated from field: string created_by = 7;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: mono.datagateway.v1.CaptureOutputProjection projection = 8;
   */ _define_property(this, "projection", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.CaptureOutputOverride overrides = 9;
   */ _define_property(this, "overrides", []), /**
   * @generated from field: repeated mono.datagateway.v1.CaptureOutputOverrideDecision decisions = 10;
   */ _define_property(this, "decisions", []), /**
   * @generated from field: mono.datagateway.v1.CaptureOutputExternalFile external_file = 11;
   */ _define_property(this, "externalFile", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureOutputVersion, "runtime", proto3);
_define_property(CaptureOutputVersion, "typeName", "mono.datagateway.v1.CaptureOutputVersion");
_define_property(CaptureOutputVersion, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "output_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "parent_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "operation",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "created_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "projection",
            kind: "message",
            T: CaptureOutputProjection
        },
        {
            no: 9,
            name: "overrides",
            kind: "message",
            T: CaptureOutputOverride,
            repeated: true
        },
        {
            no: 10,
            name: "decisions",
            kind: "message",
            T: CaptureOutputOverrideDecision,
            repeated: true
        },
        {
            no: 11,
            name: "external_file",
            kind: "message",
            T: CaptureOutputExternalFile
        }
    ]));
/**
 * An uploaded file is a distinct version, with no claim of structured parity.
 *
 * @generated from message mono.datagateway.v1.CaptureOutputExternalFile
 */ export class CaptureOutputExternalFile extends Message {
    static fromBinary(bytes, options) {
        return new CaptureOutputExternalFile().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureOutputExternalFile().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureOutputExternalFile().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureOutputExternalFile, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string artifact_id = 1;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: int32 artifact_version = 2;
   */ _define_property(this, "artifactVersion", 0), /**
   * @generated from field: string filename = 3;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: string checksum_sha256 = 4;
   */ _define_property(this, "checksumSha256", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureOutputExternalFile, "runtime", proto3);
_define_property(CaptureOutputExternalFile, "typeName", "mono.datagateway.v1.CaptureOutputExternalFile");
_define_property(CaptureOutputExternalFile, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "artifact_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "checksum_sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CaptureOutputChange
 */ export class CaptureOutputChange extends Message {
    static fromBinary(bytes, options) {
        return new CaptureOutputChange().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureOutputChange().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureOutputChange().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureOutputChange, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string section_key = 1;
   */ _define_property(this, "sectionKey", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * @generated from field: repeated mono.datagateway.v1.CaptureOutputSource previous_sources = 3;
   */ _define_property(this, "previousSources", []), /**
   * @generated from field: repeated mono.datagateway.v1.CaptureOutputSource current_sources = 4;
   */ _define_property(this, "currentSources", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureOutputChange, "runtime", proto3);
_define_property(CaptureOutputChange, "typeName", "mono.datagateway.v1.CaptureOutputChange");
_define_property(CaptureOutputChange, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "section_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "previous_sources",
            kind: "message",
            T: CaptureOutputSource,
            repeated: true
        },
        {
            no: 4,
            name: "current_sources",
            kind: "message",
            T: CaptureOutputSource,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CaptureOutputStalenessEvent
 */ export class CaptureOutputStalenessEvent extends Message {
    static fromBinary(bytes, options) {
        return new CaptureOutputStalenessEvent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureOutputStalenessEvent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureOutputStalenessEvent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureOutputStalenessEvent, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string version_id = 2;
   */ _define_property(this, "versionId", ""), /**
   * @generated from field: string observed_at = 3;
   */ _define_property(this, "observedAt", ""), /**
   * @generated from field: repeated mono.datagateway.v1.CaptureOutputChange changes = 4;
   */ _define_property(this, "changes", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureOutputStalenessEvent, "runtime", proto3);
_define_property(CaptureOutputStalenessEvent, "typeName", "mono.datagateway.v1.CaptureOutputStalenessEvent");
_define_property(CaptureOutputStalenessEvent, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "observed_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "changes",
            kind: "message",
            T: CaptureOutputChange,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ReviewCaptureOutputRequest
 */ export class ReviewCaptureOutputRequest extends Message {
    static fromBinary(bytes, options) {
        return new ReviewCaptureOutputRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviewCaptureOutputRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviewCaptureOutputRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviewCaptureOutputRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string capture_project_id = 3;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string template_id = 4;
   */ _define_property(this, "templateId", ""), /**
   * Empty selects current head.
   *
   * @generated from field: string version_id = 5;
   */ _define_property(this, "versionId", ""), /**
   * @generated from field: mono.datagateway.v1.CaptureOutputContext context = 6;
   */ _define_property(this, "context", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviewCaptureOutputRequest, "runtime", proto3);
_define_property(ReviewCaptureOutputRequest, "typeName", "mono.datagateway.v1.ReviewCaptureOutputRequest");
_define_property(ReviewCaptureOutputRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "template_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "context",
            kind: "message",
            T: CaptureOutputContext
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ReviewCaptureOutputResponse
 */ export class ReviewCaptureOutputResponse extends Message {
    static fromBinary(bytes, options) {
        return new ReviewCaptureOutputResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviewCaptureOutputResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviewCaptureOutputResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviewCaptureOutputResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CaptureOutputVersion current = 1;
   */ _define_property(this, "current", void 0), /**
   * @generated from field: mono.datagateway.v1.CaptureOutputProjection prospective = 2;
   */ _define_property(this, "prospective", void 0), /**
   * @generated from field: string source_fingerprint = 3;
   */ _define_property(this, "sourceFingerprint", ""), /**
   * @generated from field: string head_id = 4;
   */ _define_property(this, "headId", ""), /**
   * @generated from field: repeated mono.datagateway.v1.CaptureOutputStalenessEvent history = 5;
   */ _define_property(this, "history", []), /**
   * @generated from field: repeated mono.datagateway.v1.CaptureOutputChange changes = 6;
   */ _define_property(this, "changes", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviewCaptureOutputResponse, "runtime", proto3);
_define_property(ReviewCaptureOutputResponse, "typeName", "mono.datagateway.v1.ReviewCaptureOutputResponse");
_define_property(ReviewCaptureOutputResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "current",
            kind: "message",
            T: CaptureOutputVersion
        },
        {
            no: 2,
            name: "prospective",
            kind: "message",
            T: CaptureOutputProjection
        },
        {
            no: 3,
            name: "source_fingerprint",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "head_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "history",
            kind: "message",
            T: CaptureOutputStalenessEvent,
            repeated: true
        },
        {
            no: 6,
            name: "changes",
            kind: "message",
            T: CaptureOutputChange,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SaveCaptureOutputVersionRequest
 */ export class SaveCaptureOutputVersionRequest extends Message {
    static fromBinary(bytes, options) {
        return new SaveCaptureOutputVersionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveCaptureOutputVersionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveCaptureOutputVersionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveCaptureOutputVersionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string capture_project_id = 3;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string template_id = 4;
   */ _define_property(this, "templateId", ""), /**
   * @generated from field: string operation = 5;
   */ _define_property(this, "operation", ""), /**
   * @generated from field: string expected_head_id = 6;
   */ _define_property(this, "expectedHeadId", ""), /**
   * Required for generate/regenerate; obtained from ReviewCaptureOutput.
   *
   * @generated from field: string reviewed_source_fingerprint = 7;
   */ _define_property(this, "reviewedSourceFingerprint", ""), /**
   * @generated from field: repeated mono.datagateway.v1.CaptureOutputOverride overrides = 8;
   */ _define_property(this, "overrides", []), /**
   * Regenerate must explicitly decide every prior override. A replacement can
   * omit the override to use source wording, or supply explicitly edited wording.
   *
   * @generated from field: repeated mono.datagateway.v1.CaptureOutputOverrideDecision decisions = 9;
   */ _define_property(this, "decisions", []), /**
   * Only external; metadata verified against owning artifact rows.
   *
   * @generated from field: string artifact_id = 10;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: mono.datagateway.v1.CaptureOutputContext context = 11;
   */ _define_property(this, "context", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveCaptureOutputVersionRequest, "runtime", proto3);
_define_property(SaveCaptureOutputVersionRequest, "typeName", "mono.datagateway.v1.SaveCaptureOutputVersionRequest");
_define_property(SaveCaptureOutputVersionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "template_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "operation",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "expected_head_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "reviewed_source_fingerprint",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "overrides",
            kind: "message",
            T: CaptureOutputOverride,
            repeated: true
        },
        {
            no: 9,
            name: "decisions",
            kind: "message",
            T: CaptureOutputOverrideDecision,
            repeated: true
        },
        {
            no: 10,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "context",
            kind: "message",
            T: CaptureOutputContext
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SaveCaptureOutputVersionResponse
 */ export class SaveCaptureOutputVersionResponse extends Message {
    static fromBinary(bytes, options) {
        return new SaveCaptureOutputVersionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveCaptureOutputVersionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveCaptureOutputVersionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveCaptureOutputVersionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CaptureOutputVersion version = 1;
   */ _define_property(this, "version", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveCaptureOutputVersionResponse, "runtime", proto3);
_define_property(SaveCaptureOutputVersionResponse, "typeName", "mono.datagateway.v1.SaveCaptureOutputVersionResponse");
_define_property(SaveCaptureOutputVersionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "version",
            kind: "message",
            T: CaptureOutputVersion
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCaptureOutputVersionsRequest
 */ export class ListCaptureOutputVersionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureOutputVersionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureOutputVersionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureOutputVersionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureOutputVersionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string capture_project_id = 3;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string template_id = 4;
   */ _define_property(this, "templateId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureOutputVersionsRequest, "runtime", proto3);
_define_property(ListCaptureOutputVersionsRequest, "typeName", "mono.datagateway.v1.ListCaptureOutputVersionsRequest");
_define_property(ListCaptureOutputVersionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "template_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCaptureOutputVersionsResponse
 */ export class ListCaptureOutputVersionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureOutputVersionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureOutputVersionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureOutputVersionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureOutputVersionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.CaptureOutputVersion versions = 1;
   */ _define_property(this, "versions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureOutputVersionsResponse, "runtime", proto3);
_define_property(ListCaptureOutputVersionsResponse, "typeName", "mono.datagateway.v1.ListCaptureOutputVersionsResponse");
_define_property(ListCaptureOutputVersionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "versions",
            kind: "message",
            T: CaptureOutputVersion,
            repeated: true
        }
    ]));
/**
 * A reusable upstream baseline, never an approval of Proposal content or price.
 *
 * @generated from message mono.datagateway.v1.CaptureOutputHandoff
 */ export class CaptureOutputHandoff extends Message {
    static fromBinary(bytes, options) {
        return new CaptureOutputHandoff().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureOutputHandoff().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureOutputHandoff().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureOutputHandoff, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string proposal_project_id = 3;
   */ _define_property(this, "proposalProjectId", ""), /**
   * @generated from field: string output_version_id = 4;
   */ _define_property(this, "outputVersionId", ""), /**
   * @generated from field: mono.datagateway.v1.CaptureOutputVersion content = 5;
   */ _define_property(this, "content", void 0), /**
   * @generated from field: string created_at = 6;
   */ _define_property(this, "createdAt", ""), /**
   * @generated from field: string created_by = 7;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: string permission_context = 8;
   */ _define_property(this, "permissionContext", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureOutputHandoff, "runtime", proto3);
_define_property(CaptureOutputHandoff, "typeName", "mono.datagateway.v1.CaptureOutputHandoff");
_define_property(CaptureOutputHandoff, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "proposal_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "output_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "content",
            kind: "message",
            T: CaptureOutputVersion
        },
        {
            no: 6,
            name: "created_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "permission_context",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateCaptureOutputHandoffRequest
 */ export class CreateCaptureOutputHandoffRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateCaptureOutputHandoffRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateCaptureOutputHandoffRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateCaptureOutputHandoffRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateCaptureOutputHandoffRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string capture_project_id = 3;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string proposal_project_id = 4;
   */ _define_property(this, "proposalProjectId", ""), /**
   * @generated from field: string output_version_id = 5;
   */ _define_property(this, "outputVersionId", ""), /**
   * Empty selects the whole structured version.
   *
   * @generated from field: repeated string section_keys = 6;
   */ _define_property(this, "sectionKeys", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateCaptureOutputHandoffRequest, "runtime", proto3);
_define_property(CreateCaptureOutputHandoffRequest, "typeName", "mono.datagateway.v1.CreateCaptureOutputHandoffRequest");
_define_property(CreateCaptureOutputHandoffRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "proposal_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "output_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "section_keys",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateCaptureOutputHandoffResponse
 */ export class CreateCaptureOutputHandoffResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateCaptureOutputHandoffResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateCaptureOutputHandoffResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateCaptureOutputHandoffResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateCaptureOutputHandoffResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CaptureOutputHandoff handoff = 1;
   */ _define_property(this, "handoff", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateCaptureOutputHandoffResponse, "runtime", proto3);
_define_property(CreateCaptureOutputHandoffResponse, "typeName", "mono.datagateway.v1.CreateCaptureOutputHandoffResponse");
_define_property(CreateCaptureOutputHandoffResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "handoff",
            kind: "message",
            T: CaptureOutputHandoff
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCaptureOutputHandoffsRequest
 */ export class ListCaptureOutputHandoffsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureOutputHandoffsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureOutputHandoffsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureOutputHandoffsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureOutputHandoffsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string proposal_project_id = 3;
   */ _define_property(this, "proposalProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureOutputHandoffsRequest, "runtime", proto3);
_define_property(ListCaptureOutputHandoffsRequest, "typeName", "mono.datagateway.v1.ListCaptureOutputHandoffsRequest");
_define_property(ListCaptureOutputHandoffsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "proposal_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCaptureOutputHandoffsResponse
 */ export class ListCaptureOutputHandoffsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureOutputHandoffsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureOutputHandoffsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureOutputHandoffsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureOutputHandoffsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.CaptureOutputHandoff handoffs = 1;
   */ _define_property(this, "handoffs", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureOutputHandoffsResponse, "runtime", proto3);
_define_property(ListCaptureOutputHandoffsResponse, "typeName", "mono.datagateway.v1.ListCaptureOutputHandoffsResponse");
_define_property(ListCaptureOutputHandoffsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "handoffs",
            kind: "message",
            T: CaptureOutputHandoff,
            repeated: true
        }
    ]));
/**
 * SAD-510: settings and explicit authority reference an immutable output version.
 *
 * @generated from message mono.datagateway.v1.CaptureOutputPresentation
 */ export class CaptureOutputPresentation extends Message {
    static fromBinary(bytes, options) {
        return new CaptureOutputPresentation().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureOutputPresentation().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureOutputPresentation().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureOutputPresentation, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string output_version_id = 1;
   */ _define_property(this, "outputVersionId", ""), /**
   * @generated from field: int32 revision = 2;
   */ _define_property(this, "revision", 0), /**
   * @generated from field: string theme = 3;
   */ _define_property(this, "theme", ""), /**
   * @generated from field: string layout = 4;
   */ _define_property(this, "layout", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureOutputPresentation, "runtime", proto3);
_define_property(CaptureOutputPresentation, "typeName", "mono.datagateway.v1.CaptureOutputPresentation");
_define_property(CaptureOutputPresentation, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "output_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "revision",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "theme",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "layout",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CaptureOutputDisposition
 */ export class CaptureOutputDisposition extends Message {
    static fromBinary(bytes, options) {
        return new CaptureOutputDisposition().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureOutputDisposition().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureOutputDisposition().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureOutputDisposition, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string output_version_id = 2;
   */ _define_property(this, "outputVersionId", ""), /**
   * @generated from field: int32 presentation_revision = 3;
   */ _define_property(this, "presentationRevision", 0), /**
   * @generated from field: string action = 4;
   */ _define_property(this, "action", ""), /**
   * @generated from field: string reason = 5;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: string created_by = 6;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: string created_at = 7;
   */ _define_property(this, "createdAt", ""), /**
   * @generated from field: string permission_context = 8;
   */ _define_property(this, "permissionContext", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureOutputDisposition, "runtime", proto3);
_define_property(CaptureOutputDisposition, "typeName", "mono.datagateway.v1.CaptureOutputDisposition");
_define_property(CaptureOutputDisposition, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "output_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "presentation_revision",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "action",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "created_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "permission_context",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CaptureOutputExportBasis
 */ export class CaptureOutputExportBasis extends Message {
    static fromBinary(bytes, options) {
        return new CaptureOutputExportBasis().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureOutputExportBasis().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureOutputExportBasis().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureOutputExportBasis, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CaptureOutputVersion version = 1;
   */ _define_property(this, "version", void 0), /**
   * @generated from field: mono.datagateway.v1.CaptureOutputPresentation presentation = 2;
   */ _define_property(this, "presentation", void 0), /**
   * @generated from field: string authorization_id = 3;
   */ _define_property(this, "authorizationId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureOutputExportBasis, "runtime", proto3);
_define_property(CaptureOutputExportBasis, "typeName", "mono.datagateway.v1.CaptureOutputExportBasis");
_define_property(CaptureOutputExportBasis, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "version",
            kind: "message",
            T: CaptureOutputVersion
        },
        {
            no: 2,
            name: "presentation",
            kind: "message",
            T: CaptureOutputPresentation
        },
        {
            no: 3,
            name: "authorization_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetCaptureOutputPresentationRequest
 */ export class GetCaptureOutputPresentationRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetCaptureOutputPresentationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCaptureOutputPresentationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCaptureOutputPresentationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCaptureOutputPresentationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string capture_project_id = 3;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string output_version_id = 4;
   */ _define_property(this, "outputVersionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCaptureOutputPresentationRequest, "runtime", proto3);
_define_property(GetCaptureOutputPresentationRequest, "typeName", "mono.datagateway.v1.GetCaptureOutputPresentationRequest");
_define_property(GetCaptureOutputPresentationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "output_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetCaptureOutputPresentationResponse
 */ export class GetCaptureOutputPresentationResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetCaptureOutputPresentationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCaptureOutputPresentationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCaptureOutputPresentationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCaptureOutputPresentationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CaptureOutputPresentation presentation = 1;
   */ _define_property(this, "presentation", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.CaptureOutputDisposition dispositions = 2;
   */ _define_property(this, "dispositions", []), /**
   * @generated from field: repeated string allowed_actions = 3;
   */ _define_property(this, "allowedActions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCaptureOutputPresentationResponse, "runtime", proto3);
_define_property(GetCaptureOutputPresentationResponse, "typeName", "mono.datagateway.v1.GetCaptureOutputPresentationResponse");
_define_property(GetCaptureOutputPresentationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "presentation",
            kind: "message",
            T: CaptureOutputPresentation
        },
        {
            no: 2,
            name: "dispositions",
            kind: "message",
            T: CaptureOutputDisposition,
            repeated: true
        },
        {
            no: 3,
            name: "allowed_actions",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SaveCaptureOutputPresentationRequest
 */ export class SaveCaptureOutputPresentationRequest extends Message {
    static fromBinary(bytes, options) {
        return new SaveCaptureOutputPresentationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveCaptureOutputPresentationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveCaptureOutputPresentationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveCaptureOutputPresentationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string capture_project_id = 3;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string output_version_id = 4;
   */ _define_property(this, "outputVersionId", ""), /**
   * @generated from field: int32 expected_revision = 5;
   */ _define_property(this, "expectedRevision", 0), /**
   * @generated from field: string theme = 6;
   */ _define_property(this, "theme", ""), /**
   * @generated from field: string layout = 7;
   */ _define_property(this, "layout", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveCaptureOutputPresentationRequest, "runtime", proto3);
_define_property(SaveCaptureOutputPresentationRequest, "typeName", "mono.datagateway.v1.SaveCaptureOutputPresentationRequest");
_define_property(SaveCaptureOutputPresentationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "output_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "expected_revision",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "theme",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "layout",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SaveCaptureOutputPresentationResponse
 */ export class SaveCaptureOutputPresentationResponse extends Message {
    static fromBinary(bytes, options) {
        return new SaveCaptureOutputPresentationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveCaptureOutputPresentationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveCaptureOutputPresentationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveCaptureOutputPresentationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CaptureOutputPresentation presentation = 1;
   */ _define_property(this, "presentation", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveCaptureOutputPresentationResponse, "runtime", proto3);
_define_property(SaveCaptureOutputPresentationResponse, "typeName", "mono.datagateway.v1.SaveCaptureOutputPresentationResponse");
_define_property(SaveCaptureOutputPresentationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "presentation",
            kind: "message",
            T: CaptureOutputPresentation
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RecordCaptureOutputDispositionRequest
 */ export class RecordCaptureOutputDispositionRequest extends Message {
    static fromBinary(bytes, options) {
        return new RecordCaptureOutputDispositionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordCaptureOutputDispositionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordCaptureOutputDispositionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordCaptureOutputDispositionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string capture_project_id = 3;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string output_version_id = 4;
   */ _define_property(this, "outputVersionId", ""), /**
   * @generated from field: int32 presentation_revision = 5;
   */ _define_property(this, "presentationRevision", 0), /**
   * @generated from field: string action = 6;
   */ _define_property(this, "action", ""), /**
   * @generated from field: string reason = 7;
   */ _define_property(this, "reason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordCaptureOutputDispositionRequest, "runtime", proto3);
_define_property(RecordCaptureOutputDispositionRequest, "typeName", "mono.datagateway.v1.RecordCaptureOutputDispositionRequest");
_define_property(RecordCaptureOutputDispositionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "output_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "presentation_revision",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "action",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RecordCaptureOutputDispositionResponse
 */ export class RecordCaptureOutputDispositionResponse extends Message {
    static fromBinary(bytes, options) {
        return new RecordCaptureOutputDispositionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordCaptureOutputDispositionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordCaptureOutputDispositionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordCaptureOutputDispositionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CaptureOutputDisposition disposition = 1;
   */ _define_property(this, "disposition", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordCaptureOutputDispositionResponse, "runtime", proto3);
_define_property(RecordCaptureOutputDispositionResponse, "typeName", "mono.datagateway.v1.RecordCaptureOutputDispositionResponse");
_define_property(RecordCaptureOutputDispositionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "disposition",
            kind: "message",
            T: CaptureOutputDisposition
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.PrepareCaptureOutputExportRequest
 */ export class PrepareCaptureOutputExportRequest extends Message {
    static fromBinary(bytes, options) {
        return new PrepareCaptureOutputExportRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PrepareCaptureOutputExportRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PrepareCaptureOutputExportRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PrepareCaptureOutputExportRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string capture_project_id = 3;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string output_version_id = 4;
   */ _define_property(this, "outputVersionId", ""), /**
   * @generated from field: int32 presentation_revision = 5;
   */ _define_property(this, "presentationRevision", 0), /**
   * @generated from field: string format = 6;
   */ _define_property(this, "format", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PrepareCaptureOutputExportRequest, "runtime", proto3);
_define_property(PrepareCaptureOutputExportRequest, "typeName", "mono.datagateway.v1.PrepareCaptureOutputExportRequest");
_define_property(PrepareCaptureOutputExportRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "output_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "presentation_revision",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "format",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.PrepareCaptureOutputExportResponse
 */ export class PrepareCaptureOutputExportResponse extends Message {
    static fromBinary(bytes, options) {
        return new PrepareCaptureOutputExportResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PrepareCaptureOutputExportResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PrepareCaptureOutputExportResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PrepareCaptureOutputExportResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CaptureOutputExportBasis basis = 1;
   */ _define_property(this, "basis", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PrepareCaptureOutputExportResponse, "runtime", proto3);
_define_property(PrepareCaptureOutputExportResponse, "typeName", "mono.datagateway.v1.PrepareCaptureOutputExportResponse");
_define_property(PrepareCaptureOutputExportResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "basis",
            kind: "message",
            T: CaptureOutputExportBasis
        }
    ]));
